<p>See <a
href="https://learn.microsoft.com/en-us/azure/ai-services/openai/how-to/function-calling"
target="_blank">tools calling documentation</a> and <a
href="https://json-schema.org/understanding-json-schema"
target="_blank">JSON
Schema</a>
for
details. Extra guidance is available <a
href="https://learn.microsoft.com/en-us/azure/ai-services/openai/how-to/function-calling#provide-more-details-in-your-function-definition"
target="_blank">here</a>.</p>

<form [formGroup]="agentForm">
  <div class="form-wrapper input-wrapper">
    <mat-form-field class="form-field">
      <mat-label>Definition</mat-label>
      <textarea matInput formControlName="definition" cdkTextareaAutosize
      cdkAutosizeMinRows="3" ></textarea>

      @if (agentForm.get('definition')!.hasError('required')) {
          <mat-error>Agent definition is required.</mat-error>
      }
      @if (agentForm.get('definition')!.hasError('agentName')) {
          <mat-error>{{ agentForm.get('definition')!.getError('agentName') }}</mat-error>
      }
    </mat-form-field>

    <mat-form-field class="form-field">
      <mat-label>System Message (Optional)</mat-label>
      <textarea matInput formControlName="systemMessage" cdkTextareaAutosize
      cdkAutosizeMinRows="3" ></textarea>
    </mat-form-field>
  </div>
</form>
